import { Box, Grid, Typography } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { Plans } from "schemas/payments";

import styles from "../styles";

const ProCard = () => {
  const { plans } = useContext(SubscriptionContext);
  if (!plans) return <>s</>;
  return (
    <Box sx={[styles.card, { backgroundColor: "primary.main" }]}>
      <Box sx={[styles.chip, { backgroundColor: "yellow.main" }]}>
        11x more likely to land a deal
      </Box>

      <Grid container justifyContent="space-between" alignItems="flex-end">
        <Typography sx={styles.planName} variant="h4" alignItems="flex-end">
          Pro
        </Typography>

        <Box>
          {" "}
          <Box sx={styles.startAtText}>
            Starts at <br />
          </Box>
          <Box sx={styles.priceText}>${plans[Plans.PRO_YEARLY]?.price}/mo</Box>
        </Box>
      </Grid>
    </Box>
  );
};

export default ProCard;
